export default "__VITE_ASSET__41db44bc__"